<template>
  <div v-show="vk_common_visible" :class="keyboardClass"></div>
</template>

<script>
import Keyboard from 'simple-keyboard';
import 'simple-keyboard/build/css/index.css';
import { mapState } from 'vuex';

export default {
  name: 'SimpleKeyboardCommon',
  props: {
    keyboardClass: {
      default: 'simple-keyboard-common',
      type: String,
    },
    input: {
      type: String,
    },
  },
  data: () => ({
    keyboard: null,
  }),
  computed: {
    ...mapState('helper', ['vk_common_visible', 'vk_common_input']),
  },
  mounted() {
    this.keyboard = new Keyboard(this.keyboardClass, {
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
    });
  },
  methods: {
    onChange(input) {
      this.vk_common_input.value = input;
      this.vk_common_input.dispatchEvent(new Event('input'));
      this.vk_common_input.dispatchEvent(new Event('keyup'));
    },
    onKeyPress(button) {
      this.$emit('onKeyPress', button);

      /**
       * If you want to handle the shift and caps lock buttons
       */
      if (button === '{shift}' || button === '{lock}') this.handleShift();
    },
    handleShift() {
      let currentLayout = this.keyboard.options.layoutName;
      let shiftToggle = currentLayout === 'default' ? 'shift' : 'default';

      this.keyboard.setOptions({
        layoutName: shiftToggle,
      });
    },
  },
  watch: {
    input(input) {
      this.keyboard.setInput(input);
    },
  },
};
</script>

<style lang="scss">
winput {
  width: 100%;
  height: 300px;
  padding: 20px;
  font-size: 20px;
  border: none;
  box-sizing: border-box;
}

.simple-keyboard-common {
  position: fixed;
  z-index: 9999999999999;
  bottom: 0;
  left: calc(calc(100vw - 1000px) / 2);
  max-width: 1000px !important;

  background-color: var(--color6);

  .hg-button {
    background: var(--color4);
    height: 60px !important;
  }
}
</style>
